import { Divider, Grid, Typography } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import React, { FC, ReactElement } from "react";

interface i_chattable {
  rows: [];
  columns: GridColDef[];
}

const TableChatDisplay: FC<any> = ({
  rows,
  columns,
}: i_chattable): ReactElement => {
  return (
    <Grid
      sx={{
        width: "550px",
      }}
    >
      <DataGrid rows={rows} columns={columns} pageSizeOptions={[5, 10, 25]} />
    </Grid>
  );
};

export default TableChatDisplay;
